import { FunctionComponent } from 'react';
import { SearchContext } from 'components/search/SearchContext';
import { SearchNavigation } from 'components/search/SearchNavigation';
import { SearchRedirect } from 'components/search/SearchRedirect';
import { SegmentedSearchHero } from 'components/search/SegmentedSearchHero';
import { WidgetConsumerPageContent } from 'components/www/WidgetConsumerPageContent';
import { useBusinessGroup } from 'hooks/useBusinessGroups';
import { useLocation, useParams } from 'react-router';

export const GroupSearchLanding: FunctionComponent = () => {
  const { groupSlug } = useParams<{ groupSlug: string }>();
  const businessGroup = useBusinessGroup(groupSlug);
  const title = businessGroup?.name ?? '';
  const location = useLocation();

  const currencyCode = 'USD';
  const locale = 'en-US';

  return (
    <>
      <SearchNavigation />
      <SearchRedirect type="group" />
      <SearchContext locale={locale} currencyCode={currencyCode} type="group">
        <div className="PageContent PageContent--page-search">
          <SegmentedSearchHero businessGroup={businessGroup} title={title} />

          <div className="DiscoverPage-results" data-testid="discoverpage-results">
            <WidgetConsumerPageContent pathname={location.pathname} standAlone={false} />
          </div>
        </div>
      </SearchContext>
    </>
  );
};
